function isMobile() {
  if (typeof navigator === "undefined") return false;
  return /Mobi|Android|iPhone|iPad|iPod|Windows Phone|webOS|BlackBerry/i.test(
    navigator.userAgent
  );
}
const getCurrentDomain = () => {
  if (typeof window !== "undefined") {
    return window.location.origin;
  }
  return "";
};

function canPlayWebm() {
  if (typeof document === "undefined") return false;
  const video = document.createElement("video");
  if (!video.canPlayType) return false;

  const result = video.canPlayType('video/webm; codecs="vp8, vorbis"');
  return result === "probably"; // 只接受“probably”为真
}

const domain = getCurrentDomain();
const webmUrl = domain + "/videos/hg-introduction-video.webm";
const mp4Url = domain + "/videos/hg-introduction-video.mp4";
const tinyMp4Url = domain + "/videos/hg-introduction-video.mp4";
const poster = domain + "/images/mobile/poster-time.png";
const getUrl = () => {
  const canWebm = canPlayWebm();
  if (isMobile()) {
    return tinyMp4Url;
  } else if (canWebm) {
    return webmUrl;
  } else {
    return mp4Url;
  }
};

export const conf = {
  /**
   * 基础功能配置
   * */
  id: "xg-player-wrap", // 占位dom元素
  width: "100%",
  height: "100%", // 视频宽高尺寸
  url: getUrl(), // 视频源
  poster: poster, // 视频封面
  autoplay: true, // 是否自动播放，不自动播放，浏览器有限制规则
  autoplayMuted: true, // 是否自动播放（静音播放）
  videoInit: true, // 是否默认初始化video，默认初始化，默认true
  playsinline: true, // 是否启用内联播放模式，仅移动端生效
  rotateFullscreen: true,
  // 添加 iOS 端需要的内联播放属性
  "webkit-playsinline": true,
  "x5-playsinline": true,
  "x5-video-player-type": "h5",
  "x5-video-player-fullscreen": "false",
  "x-webkit-airplay": "allow",
  defaultPlaybackRate: 1, // 默认播放速度（可选：0.5/0.75/1/1.5/2等）
  volume: 0.72, // 播放音量（可选：0 ~ 1）
  loop: true, // 是否循环播放，默认不循环播放
  startTime: 0, // 点播模式下，初始起播时间
  videoAttributes: {
    // 在 videoAttributes 中也添加这些属性以确保兼容性
    playsinline: true,
    "webkit-playsinline": true,
    "x5-playsinline": true,
    "x5-video-player-type": "h5",
    "x5-video-player-fullscreen": "false",
    "x-webkit-airplay": "allow",
  }, // video扩展属性，暂且不配置
  lang: "zh-cn", // 播放器初始显示语言，设置为中文
  fluid: true, // 是否流式布局（宽高优先于流失布局，默认16:9）注掉上方宽高看效果
  fitVideoSize: "fixed", // 保持容器宽/高，不做适配，按照容器来
  videoFillMode: "auto", // 宽高不够自动底色填充（fill拉伸填充等...）
  seekedStatus: "play", // 跳转后继续播放
  // 播放器进度条故事点信息数组
  // progressDot: [
  //   {
  //     id: 0, // 唯一标识，用于删除的时候索引
  //     time: 30, // 展示的时间点，例子为在播放到10s钟的时候展示
  //     text: "进度条信息提示...", // hover的时候展示文案，可以为空
  //     duration: 5, // 展示时间跨度，单位为s
  //     style: {
  //       // 指定样式
  //       backgroundColor: "pink",
  //     },
  //   },
  // ],
  thumbnail: null, // 进度条预览图配置，普通业务用不到
  marginControls: false, // 是否开启画面和控制栏分离模式，不开启空间多一些
  domEventType: "default", // 响应的事件类型，不用指定，用默认的即可
  /**
   * 交互功能配置（一般使用默认即可）
   * */
  /**
   * 插件配置，根据需求自选
   * */
  icons: {}, // 使用默认的icon图标
  i18n: [], // 使用默认的中文
  // fitVideoSize: "auto",
  // videoFillMode: "cover",
  // 自定义一些颜色
  commonStyle: {
    progressColor: "green", // 整个进度条颜色
    playedColor: "chocolate", // 已播放的进度条颜色
    volumeColor: "pink", // 音量大小竖向滑块颜色
  },
  inactivityTimeout: 3000, // 3秒无操作后自动隐藏控制栏
  controls: true, // 是否使用底部控制栏，默认使用
  // fullscreen: true, // 是否使用全屏功能，默认使用
  // controls: {
  //   mode: "normal", // 正常模式
  //   disable: true, // 启用控制栏
  //   autoHide: false,
  //   list: [
  //     // 自定义控制栏按钮顺序和显示内容
  //     {
  //       name: "mute", // ✅ 仅保留静音按钮
  //       position: "right",
  //     },
  //     {
  //       name: "mute", // ✅ 仅保留静音按钮
  //       position: "left",
  //     },
  //     // 不添加 progress、fullscreen 等其他项
  //   ],
  // },
  ignores: [
    "time",
    "definition",
    "error",
    "fullscreen",
    "i18n",
    // "mobile",
    "pc",
    "progress",
  ],

  // controlsList: ["noremoteplayback"],
  miniprogress: false, // 是否使用mini进度条（当底部控制栏隐藏时生效）
  screenShot: false, // 关闭截图功能
  rotate: false, // 是否使用视频旋转插件，默认不使用
  download: false, // 是否使用下载按钮，一般不用，一般自定义控制
  pip: false, // 使用使用画中画模式，默认不用
  mini: false, // 是否使用小屏幕控件
  cssFullscreen: true, // 是否使用网页样式全屏按钮开关
  playbackRate: [0.5, 1, 1.5, 2, 3], //传入倍速可选数组
  playbackRate: false, //false，禁用倍速播放（即控制栏不显示）
  keyShortcut: false, // 是否开启快捷键模式
};
